import { render } from "./RequestFormEvent.vue?vue&type=template&id=740406a2&ts=true&lang=pug"
import script from "./RequestFormEvent.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestFormEvent.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__